import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FileTypeDto } from '@coin/importer/dto/util';
import { PopupAction } from '@coin/importer/core/util';
import { APIGatewayResponse } from '@coin/importer/core/data-access';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileTypePopupComponent } from '../../components/file-type-popup/file-type-popup.component';
import { FileTypeService } from '../../services/file-type/file-type.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'importer-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private fileTypeService = inject(FileTypeService);
  private toast = inject(ToastService);
  private _matDialog = inject(MatDialog);

  loading = true;
  private destroy$: Subject<void> = new Subject<void>();

  async ngOnInit(): Promise<void> {
    if (!this.fileTypeService.fileTypeSubject$.getValue()?.length) {
      await this.fileTypeService.loadFileTypesToSubject();
    }
    this.loading = false;
  }

  openDashboardPage(): void {
    this.router.navigate(['']);
  }

  // for testing
  deleteObjects(item: FileTypeDto): void {
    this.fileTypeService
      .deleteObjects(item)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: APIGatewayResponse) => {
        if (res.statusCode) {
          const { message } = JSON.parse(res.body);
          if (res.statusCode === 409) {
            this.toast.info(message);
          } else {
            this.toast.error(message);
          }
        }
      });
  }

  openCreateFileTypePopup(): void {
    const item = { exportAttributes: [], emailAddress: [] } as FileTypeDto;
    this._matDialog.open(FileTypePopupComponent, {
      data: { item, action: PopupAction.New }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
